import { TableHead } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { blueGrey, grey } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";

const infoTableCellSx = {
  fontSize: 18,
};
function ProductDetailList(props) {
  const { productId, listProductDetail, onClickDeleteProductDetail } = props;

  function getRedirectToUpdateState(productId, productDetailId) {
    return {
      productId,
      productDetailId,
    };
  }

  const columns = [
    "産地",
    "等級",
    "階級",
    "重量",
    "入数",
    "荷姿",
    "発注単位",
    "仕入先",
    "",
  ];
  const navigate = useNavigate();
  return (
    <>
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              商品明細一覧
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="outlined"
              onClick={() =>
                navigate(`/company/product_detail_register/`, {
                  state: { productId },
                })
              }
            >
              商品明細登録
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              {columns.map((columnName, i) => {
                return (
                  <TableCell
                    key={`${columnName}_${i}`}
                    sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                  >
                    {columnName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {listProductDetail.map((data, i) => (
              <TableRow
                key={i}
                sx={{
                  "&:hover": {
                    backgroundColor: blueGrey[50],
                  },
                  visibility: data.productDetailId ? "inherit" : "hidden",
                }}
              >
                {/* 産地 */}
                <TableCell sx={{ ...infoTableCellSx, width: 200 }}>
                  {data.origin || ""}
                </TableCell>
                {/* 等級 */}
                <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                  {data.rank || ""}
                </TableCell>
                {/* 階級 */}
                <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                  {data.productClass || ""}
                </TableCell>
                {/* 重量 */}
                <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                  {(data.weight || "") + (data.weightUnit || "")}
                </TableCell>
                {/* 重量単位 */}
                {/* <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                  {data.weightUnit || ""}
                </TableCell> */}
                {/* 入数 */}
                <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                  {data.quantity || ""}
                </TableCell>
                {/* 荷姿 */}
                <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                  {data.packing || ""}
                </TableCell>
                {/* 発注単位 */}
                <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                  {data.orderingUnit || ""}
                </TableCell>
                {/* 仕入れ先 */}
                <TableCell sx={{ ...infoTableCellSx, width: 200 }}>
                  {data.supplierName || ""}
                </TableCell>
                {/* 編集・削除 */}
                <TableCell
                  sx={{
                    width: "95%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outlined"
                    sx={{ marginRight: 3 }}
                    onClick={() =>
                      navigate(`/company/product_detail_edit/`, {
                        state: getRedirectToUpdateState(
                          productId,
                          data.productDetailId
                        ),
                      })
                    }
                  >
                    編集
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      onClickDeleteProductDetail(data);
                    }}
                  >
                    削除
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
export default ProductDetailList;
